import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const STEPS = [
  {
    num: "01",
    title: "Je décris mon projet",
    text: "Quelques questions pour comprendre mes envies, mon logement, mon budget et mes délais.",
  },
  {
    num: "02",
    title: "Nous préparons le projet",
    text: "CozyHome précise le besoin et aide à construire un projet cohérent.",
  },
  {
    num: "03",
    title: "Nous sélectionnons les professionnels",
    text: "Mise en relation avec des professionnels adaptés au projet.",
  },
  {
    num: "04",
    title: "Je suis mes travaux",
    text: "Planning, étapes, documents et avancement regroupés dans un suivi clair.",
  },
  {
    num: "05",
    title: "Je profite de mon nouveau chez-moi",
    text: "Accompagnement jusqu'à la réception du projet.",
  },
];

export const Process = ({ onStart }) => (
  <section id="process" data-testid="process-section" className="bg-cream py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-cognac sm:text-sm">
          Comment ça marche
        </p>
        <h2 className="mt-4 font-display text-4xl font-medium tracking-tight text-navy sm:text-6xl">
          Votre projet, <span className="italic text-sage">simplement.</span>
        </h2>
        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-stone-500 sm:text-base">
          De votre première idée jusqu'à la réception des travaux, CozyHome vous
          accompagne à chaque étape.
        </p>
      </Reveal>

      <ol className="mt-16 grid grid-cols-1 gap-x-8 gap-y-10 sm:grid-cols-2 lg:grid-cols-5">
        {STEPS.map((s, i) => (
          <Reveal key={s.num} delay={i * 0.08}>
            <li data-testid={`process-step-${i}`} className="group relative">
              <p className="font-display text-5xl font-medium text-wood transition-colors duration-300 group-hover:text-cognac sm:text-6xl">
                {s.num}
              </p>
              <span className="mt-4 block h-px w-10 bg-cognac/40 transition-all duration-500 group-hover:w-16 group-hover:bg-cognac" />
              <h3 className="mt-5 text-base font-bold text-navy sm:text-lg">{s.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-stone-500">{s.text}</p>
            </li>
          </Reveal>
        ))}
      </ol>

      <Reveal delay={0.15}>
        <div className="mt-16 flex justify-center">
          <motion.button
            data-testid="process-cta"
            onClick={onStart}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
            className="group flex items-center gap-2.5 rounded-full bg-navy px-8 py-4 text-sm font-bold text-white transition-colors duration-300 hover:bg-sage"
          >
            Démarrer mon projet
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </motion.button>
        </div>
      </Reveal>
    </div>
  </section>
);
